import React, { useEffect, useState } from "react";
import { Cpu, ShieldCheck } from "lucide-react";
import api from "../../lib/api";

const tierCls = (t) => t === "high" ? "text-red-700 bg-red-50 border-red-200"
  : t === "medium" ? "text-amber-700 bg-amber-50 border-amber-200"
  : "text-emerald-700 bg-emerald-50 border-emerald-200";

export default function ModelRisk() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/enterprise360/model-risk").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return null;
  return (
    <div data-testid="model-risk" className="border border-zinc-200 rounded-lg p-4 lg:col-span-2">
      <div className="text-[11px] font-semibold tracking-[0.16em] uppercase text-[var(--e360-primary)] inline-flex items-center gap-1 mb-2"><Cpu size={13} /> AI model-risk posture</div>
      <p className="text-[12px] text-zinc-500 mb-3">AI drafts and challenges — it never decides. {data.summary?.models_in_use} model(s) across {data.summary?.features} features, each grounded, human-reviewed and with a deterministic fallback.</p>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <div className="text-[10px] tracking-[0.14em] uppercase text-zinc-400 mb-1">Feature models</div>
          <div className="divide-y divide-zinc-100">
            {data.cards.map((c) => (
              <div key={c.generator} data-testid={`model-card-${c.generator}`} className="py-2">
                <div className="flex items-center justify-between gap-2 flex-wrap">
                  <span className="text-[13px] text-zinc-800 font-medium">{c.label}</span>
                  <span className="text-[11px] text-zinc-500">{c.model}</span>
                  <span className={`text-[10px] px-2 py-0.5 rounded border font-semibold ${tierCls(c.risk_tier)}`}>{c.risk_tier}</span>
                </div>
                <div className="text-[11px] text-zinc-400 mt-0.5">{c.purpose} · Control: {c.human_control} · Fallback: {c.fallback}</div>
              </div>
            ))}
          </div>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.14em] uppercase text-zinc-400 mb-1">Governance principles</div>
          <ul className="space-y-1.5">
            {data.principles.map((p, i) => (
              <li key={i} data-testid={`model-principle-${i}`} className="text-[12px] text-zinc-600 flex gap-1.5">
                <ShieldCheck size={13} className="text-emerald-600 flex-none mt-0.5" />{p}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
